<template>
  <BaseModal :visible="isVisible" size="3xl" @close="closeModal">
    <template #header>
      <div class="flex items-center text-lg">{{ $t('ui.stageDeleteModal.title') }}</div>
    </template>
    <template #body>
      <div class="mb-8 text-lg">
        <MessageNotification variant="warning" class="mb-2">
          <p>{{ $t('ui.stageDeleteModal.warning') }}</p>
        </MessageNotification>
      </div>
      <p>{{ $t('ui.stageDeleteModal.confirmation') }}</p>
    </template>
    <template #footer>
      <div class="flex items-center justify-between space-x-4">
        <button type="button" class="button-outlined-white" @click="closeModal">
          {{ $t('ui.cancel') }}
        </button>
        <button class="button-outlined-red" @click="onDelete">
          <span class="material-symbols-outlined notranslate" translate="no" aria-hidden="true"
            >delete</span
          >
          {{ $t('ui.stageDeleteModal.discard') }}
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { useStageStore } from '@/stores/stage'
import BaseModal from '@/components/common/BaseModal.vue'
import MessageNotification from '@/components/MessageNotification.vue'
import type { stageCard } from '@/lib/stageCardUtil'

const props = defineProps<{
  isVisible: boolean
  stageCardEntity: Map<string, stageCard>
}>()

const emit = defineEmits(['close'])
const closeModal = () => emit('close')

const stage = useStageStore()

const onDelete = async () => {
  props.stageCardEntity.forEach((card) => {
    card.stageKeys.forEach((stageKey) => {
      stage.reset(stageKey)
    })
  })

  closeModal()
}
</script>
